import React, { useEffect, useState } from "react";
import { Button, Header, Icon, Label, Loader, Modal, Pagination, Table, Dropdown, Input } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 as api } from "../../../../services/apis";
import { datePattern } from "../../../../utils/Utils";
import { Center } from "../Assinantes/styled";
import { Container, Content, InvoiceConfirmations, Line, Nav, ButtonOpen, GenerateReportButton, DownloadReportButton, ReportButtonContainer } from './styled'
import swal from "sweetalert";
import { ButtonSend } from "../../../../components/Admin/Pagarme/ButtonSend";
import { getUSER } from "../../../../services/auth";
import { toast } from "react-toastify";

const Faturas = () => {
  const [loading, setLoading] = useState(false);
  const [signatures, setSignatures] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [signatureSelected, setSignatureSelected] = useState(null);
  const [invoiceSelected, setInvoiceSelected] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [observation, setObservation] = useState("");
  const [loadingMail, setLoadingMail] = useState(false);
  const [dateFilter, setDateFilter] = useState('1');
  const [statusFilter, setStatusFilter] = useState();
  const [search, setSearch] = useState("");
  const [emailsIsSend, setEmailsIsSend] = useState(false);
  const [reportUrl, setReportUrl] = useState('');
  const [loadingReport, setLoadingReport] = useState(false);

  useEffect(() => {
    setLoading(true)

    api.get('/faturas', { params: { page, search, type: dateFilter, status: statusFilter || 'all' } }).then(res => {
      setSignatures(res.data.itens)
      setTotalPages(res.data.pages)
      setLoading(false)
    }).catch(err => {
      setLoading(false)
      console.error(err);
    })

  }, [page, dateFilter, search, statusFilter])

  useEffect(() => {
    verifyEmailSend()
  }, [])

  const handleUpdateInvoice = async (id) => {
    if (!paymentMethod) {
      alert("Selecione um método de pagamento");
      return;
    }
    if (!observation) {
      alert("Informe uma observação");
      return;
    }

    await api.put(`fatura/${id}/payment`, { paymentMethod, observation })
      .then(res => {
        swal("Sucesso", "Fatura atualizada com sucesso", "success").then(() => {
          closeInvoiceModal();
        })
      }).catch(err => {
        console.error(err);
        swal("Erro", "Ocorreu um erro ao atualizar a fatura", "error");
      })
  }

  const closeInvoiceModal = () => {
    setInvoiceSelected(null);
    setPaymentMethod("");
    setObservation("");
  }

  const handleSendEmail = () => {
    if (loadingMail || emailsIsSend) return;

    const execute = async () => {
      setLoadingMail(true)
      await api.post('/faturas/send-mail-pre-charge', {
        headers: {
          access_token: `voitto-token ${localStorage.getItem(
            "oauth_token"
          )}`,
        },
      }).then(res => {
        console.log(res.data)
        const emailSend = res.data.body.actions.filter(a => !!a.sendMail)
        swal("Sucesso", `${emailSend.length} email enviados`, "success");
      }).catch(err => {
        console.error(err)
      }).finally(() => verifyEmailSend())

      setLoadingMail(false)
    }
    execute()
  }

  const verifyEmailSend = async () => {
    await api.get('/faturas/logs/send-emails', {
      headers: {
        access_token: `voitto-token ${localStorage.getItem(
          "oauth_token"
        )}`,
      },
    }).then(() => setEmailsIsSend(true))
      .catch(() => setEmailsIsSend(false))
  }

  const handleGenerateReport = async () => {
    setLoadingReport(true);

    try {
      const response = await api.post('/admin/reports/invoices', {
        email: getUSER().email,
        search,
        type: dateFilter,
        status: statusFilter || 'all'
      });
  
      setReportUrl(response.data.url);
    } catch(e) {
      toast.error('Houve um erro ao gerar o relatório');
      console.log(e);
    } finally {
      setLoadingReport(false);
    }
  }
  
  return (
    <>
      <AdminMenu />
      <Container>
        <Content>
          <Nav>
            <h1>Assinaturas</h1>
            <div>
              <Dropdown
                placeholder="Consultor:"
                selection
                options={[
                  { key: 0, value: "1", text: "Todos" },
                  { key: 1, value: "2", text: "Vencendo hoje" },
                  { key: 2, value: "3", text: "Vence amanhã" },
                ]}
                onChange={(e, { value }) => setDateFilter(value)}
                value={dateFilter} />
            </div>
            <div>
              <Dropdown
                placeholder="Status Pagamento"
                selection
                clearable
                options={[
                  { key: 1, value: "pending", text: "Pendente" },
                  { key: 2, value: "paid", text: "Pago" },
                ]}
                onChange={(e, { value }) => setStatusFilter(value)}
                value={statusFilter}
              />
            </div>
            <div>
              <Input
                type="search"
                placeholder="Pesquisar indicação"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <ButtonSend
              text={'Envio de email diário'}
              onClick={handleSendEmail}
              isLoading={loadingMail}
              disabled={emailsIsSend}
            />
          </Nav>
          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>
                <Center>Id pedido</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Aluno</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>id assinatura</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Status de pagamento</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {loading ? <Loader active={loading} /> :
                signatures && signatures.map((signature) => (
                  <Table.Row>
                    <Table.Cell>
                      <Center>{signature.id_pedido}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>[{signature.id_pessoa}]: {signature.name} <br /> {signature.email}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center><a>{signature.id_assinatura}</a></Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        {signature.pending ? <Label color="red">Pendente</Label> : <Label color="green">Pago</Label>}
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center >
                        <ButtonOpen onClick={() => setSignatureSelected(signature)} >
                          faturas
                        </ButtonOpen>
                      </Center>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colspan="5">
                  <ReportButtonContainer>
                    {!reportUrl
                      ? (
                        <GenerateReportButton disabled={loadingReport} onClick={handleGenerateReport}>
                          {loadingReport ? 'Gerando...' : 'Gerar relatorio'}
                        </GenerateReportButton>
                      ) : (
                        <DownloadReportButton
                          href={reportUrl}
                          onClick={() => setReportUrl('')}
                        >
                          Baixar relatorio
                        </DownloadReportButton>
                      )
                    }
                  </ReportButtonContainer>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
          <Center>
            {!loading && (
              <Pagination
                boundaryRange={0}
                activePage={page}
                defaultActivePage={1}
                onPageChange={(e, f) => setPage(f.activePage)}
                totalPages={totalPages}
              />)}
          </Center>
          {signatureSelected && (
            <Modal
              closeIcon
              open={!!signatureSelected}
              onClose={() => setSignatureSelected(null)}
              style={{
                width: '90%'
              }}
            >
              <Header content={`Faturas do aluno: ${signatureSelected.name}`} />
              <Modal.Content >
                <h3> id_assinatura: {signatureSelected.id_assinatura}</h3>
                <div>
                  <Line header >
                    <div>Id da fatura</div>
                    <div>Ciclo</div>
                    <div>Status</div>
                    <div>Data de cobrança</div>
                    <div>Data de pagamento</div>
                    <div>Forma de pagamento</div>
                    <div>Próxima fatura</div>
                    <div>Observação</div>
                  </Line>
                  {signatureSelected.invoices.map((fatura, index) => {
                    return (
                      <Line key={index} >
                        <div>{fatura.id_invoice}</div>
                        <div>{fatura.cycle}</div>
                        <div>{fatura.status}</div>
                        <div>{datePattern(fatura.date)}</div>
                        <div>{fatura?.date_payment && datePattern(fatura.date_payment)}</div>
                        <div>{fatura.payment_method}</div>
                        <div>{datePattern(fatura.proxima_fatura)}</div>
                        <div>{fatura.obs}</div>
                        {fatura.status !== 'paid' && (
                          <div>
                            <button
                              onClick={() => setInvoiceSelected(fatura)}
                            >
                              Atualizar com pago
                            </button>
                          </div>)}
                      </Line>
                    )
                  })}
                </div>
              </Modal.Content>
            </Modal>
          )}

          {invoiceSelected && <Modal
            closeIcon
            open={!!invoiceSelected}
            onClose={() => closeInvoiceModal()}
          >
            <Modal.Content >
              <h3>Atualizar pagamento para pago</h3>
              <InvoiceConfirmations>
                <p>Método de pagamento</p>
                <input type="text" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} />
                <p>Observação</p>
                <input type="text" value={observation} onChange={(e) => setObservation(e.target.value)} />
              </InvoiceConfirmations>
            </Modal.Content>

            <Modal.Actions>
              <Button
                onClick={() => handleUpdateInvoice(invoiceSelected.id_invoice)}
                color="green"
                inverted
              >
                <Icon name="check" /> Atualizar
              </Button>
              <Button
                onClick={() => closeInvoiceModal()}
                color="red"
                inverted
              >
                <Icon name="close" /> Fechar
              </Button>
            </Modal.Actions>
          </Modal>}

        </Content>
      </Container>
    </>
  );
};

export default Faturas;
